import Menu from 'ant-design-vue/es/menu'
import Tooltip from 'ant-design-vue/es/tooltip'
import Badge from 'ant-design-vue/es/badge'
import Icon from '../Icon/index'

const { Item, SubMenu } = Menu

export default {
  name: 'SMenu',
  props: {
    menu: {
      type: Array,
      required: true
    },
    theme: {
      type: String,
      required: false,
      default: 'dark'
    },
    mode: {
      type: String,
      required: false,
      default: 'inline'
    },
    collapsed: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      openKeys: [],
      selectedKeys: [],
      cachedOpenKeys: [],
      hoverKey: ''
    }
  },
  computed: {
    rootSubmenuKeys: vm => {
      const keys = []
      vm.menu.forEach(item =>{
        keys.push(item.meta.key)
      })
      return keys
    }
  },
  mounted () {
    this.updateMenu()
  },
  watch: {
    collapsed (val) {
      if (val) {
        this.cachedOpenKeys = this.openKeys.concat()
        this.openKeys = []
      } else {
        this.openKeys = this.cachedOpenKeys
      }
    },
    $route: function () {
      this.updateMenu()
    }
  },
  methods: {
    // select menu item
    onOpenChange (openKeys) {
      // 在水平模式下时执行，并且不再执行后续
      if (this.mode === 'horizontal') {
        this.openKeys = openKeys
        return
      }
      // 非水平模式时
      const latestOpenKey = openKeys.find(key => !this.openKeys.includes(key))
      if (!this.rootSubmenuKeys.includes(latestOpenKey)) {
        this.openKeys = openKeys
      } else {
        this.openKeys = latestOpenKey ? [latestOpenKey] : []
      }
    },
    updateMenu () {
      const routes = this.$route.matched.concat()
      const { hidden } = this.$route.meta
      if (routes.length >= 3 && hidden) {
        routes.pop()
        this.selectedKeys = [routes[routes.length - 1].meta.key]
      } else {
        this.selectedKeys = [routes.pop().meta.key]
      }
      const openKeys = []
      if (this.mode === 'inline') {
        routes.forEach(item => {
          openKeys.push(item.meta.key)
        })
      }

      this.collapsed ? (this.cachedOpenKeys = openKeys) : (this.openKeys = openKeys)
    },

    // render
    renderItem (menu) {
      if (!menu.hidden) {
        return menu.children && !menu.hideChildrenInMenu ? this.renderSubMenu(menu) : this.renderMenuItem(menu)
      }
      return null
    },
    renderMenuItem (menu) {
      const target = menu.meta.target || null
      const tag = target && 'a' || 'router-link'
      const props = { to: { name: menu.name } }
      const attrs = { href: menu.path, target: menu.meta.target }

      if (menu.children && menu.hideChildrenInMenu) {
        // 把有子菜单的 并且 父菜单是要隐藏子菜单的
        // 都给子菜单增加一个 hidden 属性
        // 用来给刷新页面时， selectedKeys 做控制用
        menu.children.forEach(item => {
          item.meta = Object.assign(item.meta, { hidden: true })
        })
      }
      let style = {display:'block',overflow: 'hidden',whiteSpace: 'nowrap',textOverflow: 'ellipsis'}
      let numberStyle = {backgroundColor:'#fabe00'}
      let divStyle = {display:'flex',justifyContent:'space-between',alignItems:'center'}
      const isEnUS = this.$i18n.locale === 'en-US'
      const title = this.$t(menu.meta.title)
      return (
        <Item {...{ key: menu.meta.key }} nativeOnMouseenter={()=>this.setHoverKey(menu.meta.key)} nativeOnMouseleave={()=>this.hoverKey = ''} >
          <tag {...{ props, attrs }}>
            <div style={divStyle} title={this.$t(menu.meta.title)}>
              <div style={style} >
                {this.renderIcon(this.selectedKeys.indexOf(menu.meta.key) == -1 ?(this.hoverKey !== menu.meta.key?menu.meta.icon:menu.meta.activeIcon):menu.meta.activeIcon)}
                {isEnUS ? (
                  <Tooltip title={title} placement="top">
                    <span>{title}</span>
                  </Tooltip>
                ) : (
                  <span>{title}</span>
                )}
              </div>
              <div>
                {menu.meta.count ? <Badge numberStyle={numberStyle} count={menu.meta.count} />:<span></span> }
              </div>
            </div>
          </tag>
        </Item>
      )
    },
    setHoverKey(key){
      this.hoverKey = key
    },
    renderSubMenu (menu) {
      const itemArr = []
      if (!menu.hideChildrenInMenu) {
        menu.children.forEach(item => itemArr.push(this.renderItem(item)))
      }
      let style = {display:'block',overflow: 'hidden',whiteSpace: 'nowrap',textOverflow: 'ellipsis'}
      let numberStyle = {backgroundColor:'#fabe00'}
      let divStyle = {display:'flex',justifyContent:'space-between',alignItems:'center'}
      const isEnUS = this.$i18n.locale === 'en-US'
      const title = this.$t(menu.meta.title)
      return (
        <SubMenu {...{ key: menu.meta.key }} nativeOnMouseenter={()=>this.setHoverKey(menu.meta.key)} nativeOnMouseleave={()=>this.hoverKey = ''}>
          <span slot="title">
            <div style={divStyle}>
              <div style={style}>
                {this.renderIcon(this.openKeys.indexOf(menu.meta.key) == -1 ?(this.hoverKey !== menu.meta.key?menu.meta.icon:menu.meta.activeIcon):menu.meta.activeIcon)}
                {isEnUS ? (
                  <Tooltip title={title} placement="top">
                    <span>{title}</span>
                  </Tooltip>
                ) : (
                  <span>{title}</span>
                )}
              </div>
              <div>
                {menu.meta.count ? <Badge numberStyle={numberStyle} count={menu.meta.count} />:<span></span> }
              </div>
            </div>
          </span>
          {itemArr}
        </SubMenu>
      )
    },
    renderIcon (icon) {
      if (icon === 'none' || icon === undefined) {
        return null
      }
      const props = {}
      typeof (icon) === 'object' ? props.component = icon : props.type = icon
      return (
        <Icon style="font-size:16px" {... { props } }/>
      )
    }
  },

  render () {
    const { mode, theme, menu } = this
    const props = {
      mode: mode,
      theme: theme,
      openKeys: this.openKeys
    }
    const on = {
      select: obj => {
        this.selectedKeys = obj.selectedKeys
        this.$emit('select', obj)
      },
      openChange: this.onOpenChange
    }

    const menuTree = menu.map(item => {
      if (item.hidden) {
        return null
      }
      return this.renderItem(item)
    })
    // {...{ props, on: on }}
    return (
      <Menu vModel={this.selectedKeys} {...{ props, on: on }}>
        {menuTree}
      </Menu>
    )
  }
}
